<template>
  <BandejaAprobadasRechazadas />
</template>
<script>
import BandejaAprobadasRechazadas from "./components/BandejaAprobadasRechazadas";
export default {
  components: { BandejaAprobadasRechazadas },
};
</script>